'use strict';

angular.module('shiftTraderApp')
  .controller('WorkingTodayCtrl', function ($scope, $rootScope, $timeout, TimeService, workPeriods, me) {
    $rootScope.$broadcast('setTopNavTitle', 'Today\'s Schedule');
    $scope.me = me;
    $scope.workPeriods = _.where(workPeriods, function(wp) {
      return wp.$isAssigned() && wp.active;
    });


    var calcBins = function() {
      $scope.nowInStoreTime = TimeService.getNowInStoreTime();
      var futureEndTime = moment($scope.nowInStoreTime).add('hours', 12);

      $scope.currentlyBeingWorked = _.sortBy(_.where($scope.workPeriods, function(wp) {
        //check that the workPeriod range_twix has the nowInStoreTime in it
        return wp.range_twix.contains($scope.nowInStoreTime);
      }), function(wp) {
        return wp.start_time.unix();
      });

      $scope.workInFuture = _.sortBy(_.where($scope.workPeriods, function(wp) {
        return wp.start_time.isAfter($scope.nowInStoreTime) && wp.start_time.isBefore(futureEndTime);
      }), function(wp) {
        return wp.start_time.unix();
      });

      $timeout(calcBins, 5000);
    };
    calcBins();

  });
